import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetch = () => axios.get('cycles/');
